// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../utils/img/risk-managment/risk-managment-training.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homePage-container {
  background-color: #e4e6eb;
  padding: 0 !important;
}
.homePage-container .homePage-quickAccess {
  padding-left: 0px !important;
}
.homePage-container .headers-home {
  padding: 0 !important;
  z-index: 10;
}
.homePage-container .col-sideNavBar {
  display: none;
}
.homePage-container .col-homePage {
  display: flex !important;
  flex-direction: row;
  padding-left: 0;
}
.homePage-container .container-loginCard {
  padding: 0px;
  margin-top: 10px;
  margin-bottom: -20px;
}
.homePage-container .div-carrousel-hidden2 {
  display: none;
}
.homePage-container .displayNoneNotifications {
  display: none;
}
.homePage-container .row-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  height: 95%;
  padding: 0px;
  margin: 0px;
}
.homePage-container .img-risk-managment {
  width: 100%;
  border-radius: 12px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  height: 13rem;
}
.homePage-container .img-risk-managment h3 {
  width: 30%;
  padding-left: 2rem;
  text-align: left;
  font-family: "Lato", sans-serif !important;
  font-size: 28px/34px;
  font-weight: bold;
  letter-spacing: 0px;
  color: #1a1919;
  opacity: 1;
}
.homePage-container .col-risk {
  background-color: #ffffff;
  height: 3rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.homePage-container .left-corner {
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}
.homePage-container .right-corner {
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
}
.homePage-container .link-risk {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-decoration: none !important;
  color: black;
}
.homePage-container .row-risk {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  align-self: center;
  width: 95%;
  margin: 0px;
  gap: 3px;
  margin-top: 1rem;
}
.homePage-container .col-img-risk {
  margin-top: 1rem;
  margin: 1rem;
}
.homePage-container .quickAccess-onlyMobile {
  display: none;
}
.homePage-container .h4-risk-first {
  width: 160px !important;
}
.homePage-container .dropdowns-containers-navbar {
  position: sticky;
  top: 0 !important;
  z-index: 11;
  margin: 0px !important;
  width: 100% !important;
}
.homePage-container .container-quickAccess {
  margin: -40px 0px 0px -30px !important;
  position: sticky !important;
  top: -10px !important;
  height: 101.5vh;
}
.homePage-container .container-quickAccess2 {
  margin: 0px 0px 0px -15px !important;
  position: sticky !important;
  top: -10px !important;
  height: 101.5vh;
  padding-left: 0px !important;
}
.homePage-container .second-col-homepage {
  position: relative;
  top: 50px;
}
.homePage-container .row-quickAccess-mobile {
  display: none;
}
.homePage-container .logCard-component {
  padding: 0px 16px 0px 16px;
}
.homePage-container .footer-container {
  width: 100%;
}
.homePage-container .login-container-quickAccess {
  position: sticky;
  top: 50px;
  padding: 0px !important;
  height: 80vh !important;
}
.homePage-container .login-container-quickAccess #twitter-widget-1 {
  height: 400px !important;
}
.homePage-container .login-container-quickAccess .quickAcces-container {
  margin-left: 0px !important;
  height: 100vh !important;
}
.homePage-container .login-container-quickAccess2 {
  position: sticky;
  top: 50px;
  padding: 0px !important;
  height: 80vh !important;
}
.homePage-container .login-container-quickAccess2 #twitter-widget-1 {
  height: 400px !important;
}
.homePage-container .container-components-home {
  padding: 0px !important;
}
.homePage-container .container-programs {
  padding: 1rem 30px 0px 20px !important;
}
.homePage-container .row-button-login {
  width: 30% !important;
}
.homePage-container .quickAcces-container {
  height: 100vh;
  position: sticky;
  top: 0;
}
.homePage-container .homePage-wellness-classes {
  margin-top: 2rem;
}
.homePage-container .homePage-footer {
  margin-top: 2rem;
}
.homePage-container .col-homepage-notification {
  display: flex;
}
.homePage-container .col-homepage-notification .alert {
  width: 100%;
  margin-top: 2rem;
}
.homePage-container .col-homepage-notification .alert .alert-link {
  font-family: "Lato", sans-serif !important;
}
.homePage-container .col-homepage-notification .alert-warning {
  width: 96%;
  position: relative;
  left: 40px;
  margin-bottom: -30px;
  margin-top: 20px;
  border-radius: 6px !important;
  border-color: #eb9b36 !important;
  background-color: #f4dcbe !important;
  z-index: 1;
}
.homePage-container .login-container-quickAccess {
  margin-top: -20px;
}
.homePage-container .accordion-homepage {
  display: none;
}
.homePage-container .riskManagment-hidden2 {
  display: none !important;
}

@media (min-width: 1200px) and (max-width: 1400px) {
  .riskManagment-home-container .riskManagment-images-container {
    margin-bottom: 50px !important;
  }
  .quickAcces-container {
    width: 20rem !important;
  }
}
@media (min-width: 1400px) and (max-width: 1700px) {
  .quickAcces-container {
    width: 23rem !important;
  }
}
@media (max-width: 1200px) {
  .col-sideNavBar {
    display: flex !important;
  }
  .col-homePage {
    display: flex !important;
    flex-direction: column !important;
  }
  .homePage-quickAccess {
    display: none;
  }
  .container-homepage {
    background-color: #f7f8f9;
    padding: 0 !important;
    margin: 0px 64px !important;
    width: calc(100vw - 65px) !important;
  }
  .container-homepage .container-quickAccess {
    display: none;
  }
  .container-homepage .container-quickAccess2 {
    display: none;
  }
  .container-homepage .logCard-component {
    display: none !important;
  }
  .container-homepage .login-container-quickAccess {
    display: none !important;
  }
  .quickAccess-onlyMobile {
    display: flex !important;
  }
  .quickAcces-container {
    display: none !important;
  }
  .dropdowns-containers-navbar {
    display: none !important;
  }
  .accordion-homepage {
    display: flex !important;
    padding: 0px !important;
    margin: 0px !important;
    margin: 30px 0px 0px 0px !important;
  }
  .container-logCard {
    margin: 20px;
    padding: 30px !important;
  }
  .container-loginCard {
    width: 97% !important;
    padding: 20px;
    margin: 20px;
  }
  .accordion-homepage {
    padding: 15px !important;
  }
  .accordion-homepage .alert-warning {
    width: 98% !important;
    position: relative;
    left: 14px;
  }
  .icon-notif-tablet {
    display: none;
  }
  .container-homepage .alert-warning {
    width: 97% !important;
    position: relative;
    left: 30px !important;
  }
  .accordion {
    margin-top: 20px;
  }
  .riskManagment-hidden2 {
    display: flex !important;
  }
  .footer-container {
    left: 15px !important;
  }
}
@media (max-width: 992px) {
  .container-homepage .columna {
    height: auto !important;
  }
  .container-homepage .list-group-item {
    margin: 0 !important;
    width: 100% !important;
  }
  .container-homepage .homeSchedule-container {
    max-width: 920px !important;
  }
  .container-homepage .footer-container {
    margin-top: 100px !important;
  }
  .container-homepage .riskManagment-home-container {
    max-width: 920px !important;
  }
  .navbar-label {
    display: flex;
    justify-content: flex-start !important;
    height: 3rem;
  }
}
@media (max-width: 576px) {
  .container-homepage {
    background-color: #f7f8f9;
    padding: 0 !important;
    margin: 0px 0px !important;
    width: 100% !important;
  }
  .col-homePage {
    padding-right: 0 !important;
  }
  .container-accordion {
    overflow-y: scroll;
  }
  .homePage-content {
    padding: 0 !important;
  }
  .row-quickAccess-mobile {
    display: block !important;
  }
  .quickAcces-container {
    display: flex !important;
    height: 105vh !important;
  }
  .quickAccess-list-container {
    position: relative !important;
    top: -18rem !important;
  }
  .container-title-sutitle {
    position: static !important;
    margin-top: -8rem;
  }
  .divisor-line {
    position: relative !important;
    top: -9rem !important;
  }
  .container-accordion {
    height: 25rem !important;
  }
}
.navbar-label {
  display: flex !important;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: left;
  font-family: "Lato", sans-serif !important;
  font-size: 16px;
  letter-spacing: 0px;
  color: #1a1919;
}

@media (max-width: 1200px) {
  .height-login {
    height: 70vh !important;
  }
  .height-login .container-title-sutitle {
    position: relative !important;
    top: -5rem !important;
  }
  .height-login .divisor-line {
    position: relative !important;
    top: -19rem !important;
  }
  .height-login .container-accordion {
    position: relative;
    top: -10rem !important;
  }
  .height-logout {
    height: 60vh !important;
  }
  .height-logout .container-title-sutitle {
    position: relative !important;
    top: -1rem !important;
  }
  .height-logout .divisor-line {
    position: relative !important;
    top: -12rem !important;
  }
  .height-logout .quickAccess-list-container {
    position: relative;
    top: -10rem !important;
  }
}
@media (min-width: 1700px) {
  .quickAcces-container {
    width: 28rem !important;
  }
}
.homePage-featured-articles {
  display: flex;
  align-items: flex-end;
  padding-inline: 1.5em;
}`, "",{"version":3,"sources":["webpack://./src/sass/layout/homePage/homepage.scss","webpack://./src/sass/layout/homePage/homepage.css","webpack://./src/sass/utilities/_variables.scss"],"names":[],"mappings":"AAGA;EACE,yBAAA;EACA,qBAAA;ACFF;ADGE;EACE,4BAAA;ACDJ;ADGE;EACE,qBAAA;EACA,WAAA;ACDJ;ADGE;EACE,aAAA;ACDJ;ADGE;EACE,wBAAA;EACA,mBAAA;EACA,eAAA;ACDJ;ADIE;EACE,YAAA;EACA,gBAAA;EACA,oBAAA;ACFJ;ADKE;EACE,aAAA;ACHJ;ADKE;EACE,aAAA;ACHJ;ADKE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;ACHJ;ADKE;EACE,WAAA;EACA,mBAAA;EACA,yDAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,aAAA;ACHJ;ADKI;EACE,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,0CE1DC;EF2DD,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;ACHN;ADME;EACE,yBAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;ACJJ;ADME;EACE,4BAAA;EACA,+BAAA;ACJJ;ADME;EACE,6BAAA;EACA,gCAAA;ACJJ;ADME;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,gCAAA;EACA,YAAA;ACJJ;ADME;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,QAAA;EACA,gBAAA;ACJJ;ADME;EACE,gBAAA;EACA,YAAA;ACJJ;ADOE;EACE,aAAA;ACLJ;ADQE;EACE,uBAAA;ACNJ;ADSE;EACE,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;ACPJ;ADUE;EACE,sCAAA;EACA,2BAAA;EACA,qBAAA;EACA,eAAA;ACRJ;ADWE;EACE,oCAAA;EACA,2BAAA;EACA,qBAAA;EACA,eAAA;EACA,4BAAA;ACTJ;ADYE;EACE,kBAAA;EACA,SAAA;ACVJ;ADYE;EACE,aAAA;ACVJ;ADYE;EACE,0BAAA;ACVJ;ADaE;EACE,WAAA;ACXJ;ADcE;EACE,gBAAA;EACA,SAAA;EACA,uBAAA;EACA,uBAAA;ACZJ;ADcI;EACE,wBAAA;ACZN;ADeI;EACE,2BAAA;EACA,wBAAA;ACbN;ADiBE;EACE,gBAAA;EACA,SAAA;EACA,uBAAA;EACA,uBAAA;ACfJ;ADiBI;EACE,wBAAA;ACfN;ADmBE;EACE,uBAAA;ACjBJ;ADoBE;EACE,sCAAA;AClBJ;ADqBE;EACE,qBAAA;ACnBJ;ADsBE;EACE,aAAA;EACA,gBAAA;EACA,MAAA;ACpBJ;ADuBE;EACE,gBAAA;ACrBJ;ADuBE;EACE,gBAAA;ACrBJ;ADuBE;EACE,aAAA;ACrBJ;ADuBI;EACE,WAAA;EACA,gBAAA;ACrBN;ADuBM;EACE,0CEnND;AD8LP;ADyBI;EACE,UAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,gBAAA;EACA,6BAAA;EACA,gCAAA;EACA,oCAAA;EACA,UAAA;ACvBN;AD2BE;EACE,iBAAA;ACzBJ;AD4BE;EACE,aAAA;AC1BJ;AD6BE;EACE,wBAAA;AC3BJ;;AD+BA;EAEI;IACE,8BAAA;EC7BJ;EDgCA;IACE,uBAAA;EC9BF;AACF;ADgCA;EACE;IACE,uBAAA;EC9BF;AACF;ADiCA;EACE;IACE,wBAAA;EC/BF;EDiCA;IACE,wBAAA;IACA,iCAAA;EC/BF;EDiCA;IACE,aAAA;EC/BF;EDiCA;IACE,yBAAA;IACA,qBAAA;IACA,2BAAA;IACA,oCAAA;EC/BF;EDiCE;IACE,aAAA;EC/BJ;EDkCE;IACE,aAAA;EChCJ;EDmCE;IACE,wBAAA;ECjCJ;EDoCE;IACE,wBAAA;EClCJ;EDqCA;IACE,wBAAA;ECnCF;EDqCA;IACE,wBAAA;ECnCF;EDsCA;IACE,wBAAA;ECpCF;EDuCA;IACE,wBAAA;IACA,uBAAA;IACA,sBAAA;IACA,mCAAA;ECrCF;EDwCA;IACE,YAAA;IACA,wBAAA;ECtCF;EDyCA;IACE,qBAAA;IACA,aAAA;IACA,YAAA;ECvCF;ED0CA;IACE,wBAAA;ECxCF;ED0CE;IACE,qBAAA;IACA,kBAAA;IACA,UAAA;ECxCJ;ED2CA;IACE,aAAA;ECzCF;ED6CE;IACE,qBAAA;IACA,kBAAA;IACA,qBAAA;EC3CJ;ED+CA;IACE,gBAAA;EC7CF;EDgDA;IACE,wBAAA;EC9CF;EDiDA;IACE,qBAAA;EC/CF;AACF;ADkDA;EAEI;IACE,uBAAA;ECjDJ;EDoDE;IACE,oBAAA;IACA,sBAAA;EClDJ;EDqDE;IACE,2BAAA;ECnDJ;EDsDE;IACE,4BAAA;ECpDJ;EDuDE;IACE,2BAAA;ECrDJ;EDyDA;IACE,aAAA;IACA,sCAAA;IACA,YAAA;ECvDF;AACF;AD0DA;EACE;IACE,yBAAA;IACA,qBAAA;IACA,0BAAA;IACA,sBAAA;ECxDF;ED0DA;IACE,2BAAA;ECxDF;ED2DA;IACE,kBAAA;ECzDF;ED2DA;IACE,qBAAA;ECzDF;ED2DA;IACE,yBAAA;ECzDF;ED2DA;IACE,wBAAA;IACA,wBAAA;ECzDF;ED2DA;IACE,6BAAA;IACA,sBAAA;ECzDF;ED2DA;IACE,2BAAA;IACA,iBAAA;ECzDF;ED2DA;IACE,6BAAA;IACA,qBAAA;ECzDF;ED2DA;IACE,wBAAA;ECzDF;AACF;AD4DA;EACE,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CE/aK;EFgbL,eAAA;EACA,mBAAA;EACA,cAAA;AC1DF;;AD6DA;EACE;IACE,uBAAA;EC1DF;ED2DE;IACE,6BAAA;IACA,qBAAA;ECzDJ;ED2DE;IACE,6BAAA;IACA,sBAAA;ECzDJ;ED2DE;IACE,kBAAA;IACA,sBAAA;ECzDJ;ED4DA;IACE,uBAAA;EC1DF;ED2DE;IACE,6BAAA;IACA,qBAAA;ECzDJ;ED2DE;IACE,6BAAA;IACA,sBAAA;ECzDJ;ED2DE;IACE,kBAAA;IACA,sBAAA;ECzDJ;AACF;AD8DA;EACE;IACE,uBAAA;EC5DF;AACF;AD+DA;EACE,aAAA;EACA,qBAAA;EACA,qBAAA;AC7DF","sourcesContent":["@import \"../../utilities/mixins\";\n@import \"../../utilities/variables\";\n\n.homePage-container {\n  background-color: #e4e6eb;\n  padding: 0 !important;\n  .homePage-quickAccess {\n    padding-left: 0px !important;\n  }\n  .headers-home {\n    padding: 0 !important;\n    z-index: 10;\n  }\n  .col-sideNavBar {\n    display: none;\n  }\n  .col-homePage {\n    display: flex !important;\n    flex-direction: row;\n    padding-left: 0;\n  }\n\n  .container-loginCard {\n    padding: 0px;\n    margin-top: 10px;\n    margin-bottom: -20px;\n  }\n\n  .div-carrousel-hidden2 {\n    display: none;\n  }\n  .displayNoneNotifications {\n    display: none;\n  }\n  .row-container {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    width: 100%;\n    height: 95%;\n    padding: 0px;\n    margin: 0px;\n  }\n  .img-risk-managment {\n    width: 100%;\n    border-radius: 12px;\n    background-image: url(\"../../../utils/img/risk-managment/risk-managment-training.png\");\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    height: 13rem;\n\n    h3 {\n      width: 30%;\n      padding-left: 2rem;\n      text-align: left;\n      font-family: $Font;\n      font-size: 28px/34px;\n      font-weight: bold;\n      letter-spacing: 0px;\n      color: #1a1919;\n      opacity: 1;\n    }\n  }\n  .col-risk {\n    background-color: #ffffff;\n    height: 3rem;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n  }\n  .left-corner {\n    border-top-left-radius: 12px;\n    border-bottom-left-radius: 12px;\n  }\n  .right-corner{\n    border-top-right-radius: 12px;\n    border-bottom-right-radius: 12px;\n  }\n  .link-risk {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    text-decoration: none !important;\n    color: black;\n  }\n  .row-risk {\n    display: flex;\n    flex-direction: row;\n    align-content: center;\n    justify-content: center;\n    align-self: center;\n    width: 95%;\n    margin: 0px;\n    gap: 3px;\n    margin-top: 1rem;\n  }\n  .col-img-risk {\n    margin-top: 1rem;\n    margin: 1rem;\n  }\n\n  .quickAccess-onlyMobile {\n    display: none;\n  }\n\n  .h4-risk-first{\n    width: 160px !important;\n  }\n\n  .dropdowns-containers-navbar {\n    position: sticky;\n    top: 0 !important;\n    z-index: 11;\n    margin: 0px !important;\n    width: 100% !important;\n  }\n\n  .container-quickAccess {\n    margin: -40px 0px 0px -30px !important;\n    position: sticky !important;\n    top: -10px !important;\n    height: 101.5vh;\n  }\n\n  .container-quickAccess2 {\n    margin: -0px 0px 0px -15px !important;\n    position: sticky !important;\n    top: -10px !important;\n    height: 101.5vh;\n    padding-left: 0px !important;\n  }\n\n  .second-col-homepage {\n    position: relative;\n    top: 50px;\n  }\n  .row-quickAccess-mobile {\n    display: none;\n  }\n  .logCard-component {\n    padding: 0px 16px 0px 16px;\n  }\n\n  .footer-container {\n    width: 100%;\n  }\n\n  .login-container-quickAccess {\n    position: sticky;\n    top: 50px;\n    padding: 0px !important;\n    height: 80vh !important;\n\n    #twitter-widget-1 {\n      height: 400px !important;\n    }\n\n    .quickAcces-container {\n      margin-left: 0px !important;\n      height: 100vh !important;\n    }\n  }\n\n  .login-container-quickAccess2 {\n    position: sticky;\n    top: 50px;\n    padding: 0px !important;\n    height: 80vh !important;\n\n    #twitter-widget-1 {\n      height: 400px !important;\n    }\n  }\n\n  .container-components-home {\n    padding: 0px !important;\n  }\n\n  .container-programs {\n    padding: 1rem 30px 0px 20px !important;\n  }\n\n  .row-button-login {\n    width: 30% !important;\n  }\n\n  .quickAcces-container {\n    height: 100vh;\n    position: sticky;\n    top: 0;\n  }\n\n  .homePage-wellness-classes {\n    margin-top: 2rem;\n  }\n  .homePage-footer {\n    margin-top: 2rem;\n  }\n  .col-homepage-notification {\n    display: flex;\n\n    .alert {\n      width: 100%;\n      margin-top: 2rem;\n\n      .alert-link {\n        font-family: $Font;\n      }\n    }\n\n    .alert-warning {\n      width: 96%;\n      position: relative;\n      left: 40px;\n      margin-bottom: -30px;\n      margin-top: 20px;\n      border-radius: 6px !important;\n      border-color: #eb9b36 !important;\n      background-color: #f4dcbe !important;\n      z-index: 1;\n    }\n  }\n\n  .login-container-quickAccess {\n    margin-top: -20px;\n  }\n\n  .accordion-homepage {\n    display: none;\n  }\n\n  .riskManagment-hidden2 {\n    display: none !important;\n  }\n}\n\n@media (min-width: 1200px) and (max-width: 1400px) {\n  .riskManagment-home-container {\n    .riskManagment-images-container {\n      margin-bottom: 50px !important;\n    }\n  }\n  .quickAcces-container {\n    width: 20rem !important;\n  }\n}\n@media (min-width: 1400px) and (max-width: 1700px) {\n  .quickAcces-container {\n    width: 23rem !important;\n  }\n}\n\n@media (max-width: 1200px) {\n  .col-sideNavBar {\n    display: flex !important;\n  }\n  .col-homePage {\n    display: flex !important;\n    flex-direction: column !important;\n  }\n  .homePage-quickAccess {\n    display: none;\n  }\n  .container-homepage {\n    background-color: #f7f8f9;\n    padding: 0 !important;\n    margin: 0px 64px !important;\n    width: calc(100vw - 65px) !important;\n\n    .container-quickAccess {\n      display: none;\n    }\n\n    .container-quickAccess2 {\n      display: none;\n    }\n\n    .logCard-component {\n      display: none !important;\n    }\n\n    .login-container-quickAccess {\n      display: none !important;\n    }\n  }\n  .quickAccess-onlyMobile {\n    display: flex !important;\n  }\n  .quickAcces-container {\n    display: none !important;\n  }\n\n  .dropdowns-containers-navbar {\n    display: none !important;\n  }\n\n  .accordion-homepage {\n    display: flex !important;\n    padding: 0px !important;\n    margin: 0px !important;\n    margin: 30px 0px 0px 0px !important;\n  }\n\n  .container-logCard {\n    margin: 20px;\n    padding: 30px !important;\n  }\n\n  .container-loginCard {\n    width: 97% !important;\n    padding: 20px;\n    margin: 20px;\n  }\n\n  .accordion-homepage {\n    padding: 15px !important;\n\n    .alert-warning {\n      width: 98% !important;\n      position: relative;\n      left: 14px;\n    }\n  }\n  .icon-notif-tablet {\n    display: none;\n  }\n\n  .container-homepage {\n    .alert-warning {\n      width: 97% !important;\n      position: relative;\n      left: 30px !important;\n    }\n  }\n\n  .accordion {\n    margin-top: 20px;\n  }\n\n  .riskManagment-hidden2 {\n    display: flex !important;\n  }\n\n  .footer-container {\n    left: 15px !important;\n  }\n}\n\n@media (max-width: 992px) {\n  .container-homepage {\n    .columna {\n      height: auto !important;\n    }\n\n    .list-group-item {\n      margin: 0 !important;\n      width: 100% !important;\n    }\n\n    .homeSchedule-container {\n      max-width: 920px !important;\n    }\n\n    .footer-container {\n      margin-top: 100px !important;\n    }\n\n    .riskManagment-home-container {\n      max-width: 920px !important;\n    }\n  }\n\n  .navbar-label {\n    display: flex;\n    justify-content: flex-start !important;\n    height: 3rem;\n  }\n}\n\n@media (max-width: 576px) {\n  .container-homepage {\n    background-color: #f7f8f9;\n    padding: 0 !important;\n    margin: 0px 0px !important;\n    width: 100% !important;\n  }\n  .col-homePage {\n    padding-right: 0 !important;\n  }\n\n  .container-accordion {\n    overflow-y: scroll;\n  }\n  .homePage-content {\n    padding: 0 !important;\n  }\n  .row-quickAccess-mobile {\n    display: block !important;\n  }\n  .quickAcces-container {\n    display: flex !important;\n    height: 105vh !important;\n  }\n  .quickAccess-list-container {\n    position: relative !important;\n    top: -18rem !important;\n  }\n  .container-title-sutitle {\n    position: static !important;\n    margin-top: -8rem;\n  }\n  .divisor-line {\n    position: relative !important;\n    top: -9rem !important;\n  }\n  .container-accordion {\n    height: 25rem !important;\n  }\n}\n\n.navbar-label {\n  display: flex !important;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  text-align: left;\n  font-family: $Font;\n  font-size: 12px;\n  letter-spacing: 0px;\n  color: #1a1919;\n}\n\n@media (max-width: 1200px) {\n  .height-login {\n    height: 70vh !important;\n    .container-title-sutitle {\n      position: relative !important;\n      top: -5rem !important;\n    }\n    .divisor-line {\n      position: relative !important;\n      top: -19rem !important;\n    }\n    .container-accordion {\n      position: relative;\n      top: -10rem !important;\n    }\n  }\n  .height-logout {\n    height: 60vh !important;\n    .container-title-sutitle {\n      position: relative !important;\n      top: -1rem !important;\n    }\n    .divisor-line {\n      position: relative !important;\n      top: -12rem !important;\n    }\n    .quickAccess-list-container {\n      position: relative;\n      top: -10rem !important;\n    }\n  }\n}\n\n//for all\n@media (min-width: 1700px) {\n  .quickAcces-container {\n    width: 28rem !important;\n  }\n}\n\n.homePage-featured-articles {\n  display: flex;\n  align-items: flex-end;\n  padding-inline: 1.5em;\n}",".homePage-container {\n  background-color: #e4e6eb;\n  padding: 0 !important;\n}\n.homePage-container .homePage-quickAccess {\n  padding-left: 0px !important;\n}\n.homePage-container .headers-home {\n  padding: 0 !important;\n  z-index: 10;\n}\n.homePage-container .col-sideNavBar {\n  display: none;\n}\n.homePage-container .col-homePage {\n  display: flex !important;\n  flex-direction: row;\n  padding-left: 0;\n}\n.homePage-container .container-loginCard {\n  padding: 0px;\n  margin-top: 10px;\n  margin-bottom: -20px;\n}\n.homePage-container .div-carrousel-hidden2 {\n  display: none;\n}\n.homePage-container .displayNoneNotifications {\n  display: none;\n}\n.homePage-container .row-container {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  width: 100%;\n  height: 95%;\n  padding: 0px;\n  margin: 0px;\n}\n.homePage-container .img-risk-managment {\n  width: 100%;\n  border-radius: 12px;\n  background-image: url(\"../../../utils/img/risk-managment/risk-managment-training.png\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  height: 13rem;\n}\n.homePage-container .img-risk-managment h3 {\n  width: 30%;\n  padding-left: 2rem;\n  text-align: left;\n  font-family: \"Lato\", sans-serif !important;\n  font-size: 28px/34px;\n  font-weight: bold;\n  letter-spacing: 0px;\n  color: #1a1919;\n  opacity: 1;\n}\n.homePage-container .col-risk {\n  background-color: #ffffff;\n  height: 3rem;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n.homePage-container .left-corner {\n  border-top-left-radius: 12px;\n  border-bottom-left-radius: 12px;\n}\n.homePage-container .right-corner {\n  border-top-right-radius: 12px;\n  border-bottom-right-radius: 12px;\n}\n.homePage-container .link-risk {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  text-decoration: none !important;\n  color: black;\n}\n.homePage-container .row-risk {\n  display: flex;\n  flex-direction: row;\n  align-content: center;\n  justify-content: center;\n  align-self: center;\n  width: 95%;\n  margin: 0px;\n  gap: 3px;\n  margin-top: 1rem;\n}\n.homePage-container .col-img-risk {\n  margin-top: 1rem;\n  margin: 1rem;\n}\n.homePage-container .quickAccess-onlyMobile {\n  display: none;\n}\n.homePage-container .h4-risk-first {\n  width: 160px !important;\n}\n.homePage-container .dropdowns-containers-navbar {\n  position: sticky;\n  top: 0 !important;\n  z-index: 11;\n  margin: 0px !important;\n  width: 100% !important;\n}\n.homePage-container .container-quickAccess {\n  margin: -40px 0px 0px -30px !important;\n  position: sticky !important;\n  top: -10px !important;\n  height: 101.5vh;\n}\n.homePage-container .container-quickAccess2 {\n  margin: 0px 0px 0px -15px !important;\n  position: sticky !important;\n  top: -10px !important;\n  height: 101.5vh;\n  padding-left: 0px !important;\n}\n.homePage-container .second-col-homepage {\n  position: relative;\n  top: 50px;\n}\n.homePage-container .row-quickAccess-mobile {\n  display: none;\n}\n.homePage-container .logCard-component {\n  padding: 0px 16px 0px 16px;\n}\n.homePage-container .footer-container {\n  width: 100%;\n}\n.homePage-container .login-container-quickAccess {\n  position: sticky;\n  top: 50px;\n  padding: 0px !important;\n  height: 80vh !important;\n}\n.homePage-container .login-container-quickAccess #twitter-widget-1 {\n  height: 400px !important;\n}\n.homePage-container .login-container-quickAccess .quickAcces-container {\n  margin-left: 0px !important;\n  height: 100vh !important;\n}\n.homePage-container .login-container-quickAccess2 {\n  position: sticky;\n  top: 50px;\n  padding: 0px !important;\n  height: 80vh !important;\n}\n.homePage-container .login-container-quickAccess2 #twitter-widget-1 {\n  height: 400px !important;\n}\n.homePage-container .container-components-home {\n  padding: 0px !important;\n}\n.homePage-container .container-programs {\n  padding: 1rem 30px 0px 20px !important;\n}\n.homePage-container .row-button-login {\n  width: 30% !important;\n}\n.homePage-container .quickAcces-container {\n  height: 100vh;\n  position: sticky;\n  top: 0;\n}\n.homePage-container .homePage-wellness-classes {\n  margin-top: 2rem;\n}\n.homePage-container .homePage-footer {\n  margin-top: 2rem;\n}\n.homePage-container .col-homepage-notification {\n  display: flex;\n}\n.homePage-container .col-homepage-notification .alert {\n  width: 100%;\n  margin-top: 2rem;\n}\n.homePage-container .col-homepage-notification .alert .alert-link {\n  font-family: \"Lato\", sans-serif !important;\n}\n.homePage-container .col-homepage-notification .alert-warning {\n  width: 96%;\n  position: relative;\n  left: 40px;\n  margin-bottom: -30px;\n  margin-top: 20px;\n  border-radius: 6px !important;\n  border-color: #eb9b36 !important;\n  background-color: #f4dcbe !important;\n  z-index: 1;\n}\n.homePage-container .login-container-quickAccess {\n  margin-top: -20px;\n}\n.homePage-container .accordion-homepage {\n  display: none;\n}\n.homePage-container .riskManagment-hidden2 {\n  display: none !important;\n}\n\n@media (min-width: 1200px) and (max-width: 1400px) {\n  .riskManagment-home-container .riskManagment-images-container {\n    margin-bottom: 50px !important;\n  }\n  .quickAcces-container {\n    width: 20rem !important;\n  }\n}\n@media (min-width: 1400px) and (max-width: 1700px) {\n  .quickAcces-container {\n    width: 23rem !important;\n  }\n}\n@media (max-width: 1200px) {\n  .col-sideNavBar {\n    display: flex !important;\n  }\n  .col-homePage {\n    display: flex !important;\n    flex-direction: column !important;\n  }\n  .homePage-quickAccess {\n    display: none;\n  }\n  .container-homepage {\n    background-color: #f7f8f9;\n    padding: 0 !important;\n    margin: 0px 64px !important;\n    width: calc(100vw - 65px) !important;\n  }\n  .container-homepage .container-quickAccess {\n    display: none;\n  }\n  .container-homepage .container-quickAccess2 {\n    display: none;\n  }\n  .container-homepage .logCard-component {\n    display: none !important;\n  }\n  .container-homepage .login-container-quickAccess {\n    display: none !important;\n  }\n  .quickAccess-onlyMobile {\n    display: flex !important;\n  }\n  .quickAcces-container {\n    display: none !important;\n  }\n  .dropdowns-containers-navbar {\n    display: none !important;\n  }\n  .accordion-homepage {\n    display: flex !important;\n    padding: 0px !important;\n    margin: 0px !important;\n    margin: 30px 0px 0px 0px !important;\n  }\n  .container-logCard {\n    margin: 20px;\n    padding: 30px !important;\n  }\n  .container-loginCard {\n    width: 97% !important;\n    padding: 20px;\n    margin: 20px;\n  }\n  .accordion-homepage {\n    padding: 15px !important;\n  }\n  .accordion-homepage .alert-warning {\n    width: 98% !important;\n    position: relative;\n    left: 14px;\n  }\n  .icon-notif-tablet {\n    display: none;\n  }\n  .container-homepage .alert-warning {\n    width: 97% !important;\n    position: relative;\n    left: 30px !important;\n  }\n  .accordion {\n    margin-top: 20px;\n  }\n  .riskManagment-hidden2 {\n    display: flex !important;\n  }\n  .footer-container {\n    left: 15px !important;\n  }\n}\n@media (max-width: 992px) {\n  .container-homepage .columna {\n    height: auto !important;\n  }\n  .container-homepage .list-group-item {\n    margin: 0 !important;\n    width: 100% !important;\n  }\n  .container-homepage .homeSchedule-container {\n    max-width: 920px !important;\n  }\n  .container-homepage .footer-container {\n    margin-top: 100px !important;\n  }\n  .container-homepage .riskManagment-home-container {\n    max-width: 920px !important;\n  }\n  .navbar-label {\n    display: flex;\n    justify-content: flex-start !important;\n    height: 3rem;\n  }\n}\n@media (max-width: 576px) {\n  .container-homepage {\n    background-color: #f7f8f9;\n    padding: 0 !important;\n    margin: 0px 0px !important;\n    width: 100% !important;\n  }\n  .col-homePage {\n    padding-right: 0 !important;\n  }\n  .container-accordion {\n    overflow-y: scroll;\n  }\n  .homePage-content {\n    padding: 0 !important;\n  }\n  .row-quickAccess-mobile {\n    display: block !important;\n  }\n  .quickAcces-container {\n    display: flex !important;\n    height: 105vh !important;\n  }\n  .quickAccess-list-container {\n    position: relative !important;\n    top: -18rem !important;\n  }\n  .container-title-sutitle {\n    position: static !important;\n    margin-top: -8rem;\n  }\n  .divisor-line {\n    position: relative !important;\n    top: -9rem !important;\n  }\n  .container-accordion {\n    height: 25rem !important;\n  }\n}\n.navbar-label {\n  display: flex !important;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  text-align: left;\n  font-family: \"Lato\", sans-serif !important;\n  font-size: 16px;\n  letter-spacing: 0px;\n  color: #1a1919;\n}\n\n@media (max-width: 1200px) {\n  .height-login {\n    height: 70vh !important;\n  }\n  .height-login .container-title-sutitle {\n    position: relative !important;\n    top: -5rem !important;\n  }\n  .height-login .divisor-line {\n    position: relative !important;\n    top: -19rem !important;\n  }\n  .height-login .container-accordion {\n    position: relative;\n    top: -10rem !important;\n  }\n  .height-logout {\n    height: 60vh !important;\n  }\n  .height-logout .container-title-sutitle {\n    position: relative !important;\n    top: -1rem !important;\n  }\n  .height-logout .divisor-line {\n    position: relative !important;\n    top: -12rem !important;\n  }\n  .height-logout .quickAccess-list-container {\n    position: relative;\n    top: -10rem !important;\n  }\n}\n@media (min-width: 1700px) {\n  .quickAcces-container {\n    width: 28rem !important;\n  }\n}\n.homePage-featured-articles {\n  display: flex;\n  align-items: flex-end;\n  padding-inline: 1.5em;\n}/*# sourceMappingURL=homepage.css.map */","// Utils\n$DecorationNone: none;\n$Font: \"Lato\", sans-serif !important;\n$Font-size-navbar: 12px;\n$LetterSpacing: 0px;\n\n// Colors\n$Transparent: rgba(0, 0, 0, 0);\n$RedColor: rgb(143, 0, 60, 1);\n$White: rgba(255, 255, 255, 1);\n$Black: rgba(26, 25, 25, 1);\n$MainBackgroundColor: rgba(247, 248, 249, 1);\n$SecondaryBackgroundColor: rgba(221, 208, 208, 0.5);\n$GrayColor: rgba(204, 204, 204, 1);\n$LinkColor: rgba(18, 101, 183, 1);\n$LinkSecondColor: rgba(78, 125, 162, 1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
